/* Stillwach – kleine Helfer für die Landingpage (ohne Abhängigkeiten). */
(function () {
  'use strict';

  /* ---------- Verzögerte Galeriebilder (data-sw-defer) laden ---------- */
  function loadDeferred(root) {
    (root || document).querySelectorAll('img[data-sw-defer]').forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('data-sw-defer');
    });
  }
  if (document.readyState === 'complete') setTimeout(loadDeferred, 300);
  else window.addEventListener('load', function () { setTimeout(loadDeferred, 300); });

  /* ---------- Galerie: Zähler + Punkte ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-sw-gallery-track]');
    var dots = root.querySelectorAll('[data-sw-gallery-dot]');
    var current = root.querySelector('[data-sw-gallery-current]');
    if (!track) return;
    ['touchstart', 'pointerdown', 'scroll', 'focusin'].forEach(function (ev) {
      track.addEventListener(ev, function () { loadDeferred(root); }, { passive: true, once: true });
    });
    dots.forEach(function (d) { d.addEventListener('click', function () { loadDeferred(root); }, { once: true }); });
    var slides = track.children;
    function update() {
      var i = Math.round(track.scrollLeft / Math.max(1, slides[0].offsetWidth + 8));
      i = Math.max(0, Math.min(slides.length - 1, i));
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); d.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      if (current) current.textContent = i + 1;
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var s = slides[+d.dataset.swGalleryDot];
        if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' });
      });
    });
    update();
  }


  /* ---------- Kunden-Leiste: immer zwei, automatisch wechseln ---------- */
  function initSocial(root) {
    var slides = root.querySelectorAll('.sw-social__slide');
    if (slides.length < 2 || root.dataset.swInit) return;
    root.dataset.swInit = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, ms = Math.max(2, +root.dataset.speed || 4) * 1000;
    setInterval(function () {
      if (document.hidden) return;
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active'); slides[i].removeAttribute('aria-hidden');
    }, ms);
  }

  /* ---------- Horizontale Slider: Fortschrittsbalken ---------- */
  function initRail(rail) {
    var bar = rail.parentElement.querySelector('[data-sw-progress]');
    if (!bar) return;
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var visible = rail.clientWidth / rail.scrollWidth;
      var p = max > 0 ? visible + (1 - visible) * (rail.scrollLeft / max) : 1;
      bar.style.setProperty('--sw-p', Math.round(p * 100) + '%');
      bar.parentElement.hidden = max <= 2;
    }
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Echtes Lieferdatum (Werktage Mo–Fr) ---------- */
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });
  }
  function initDelivery(el) {
    var min = parseInt(el.dataset.min, 10), max = parseInt(el.dataset.max, 10);
    if (!min) return;
    var now = new Date();
    var start = new Date(now);
    var isWorkday = now.getDay() !== 0 && now.getDay() !== 6;
    var cutoff = el.dataset.cutoff ? parseInt(el.dataset.cutoff, 10) : null;
    // Nach Bestellschluss / am Wochenende startet die Lieferzeit erst am nächsten Werktag.
    if (cutoff !== null && (!isWorkday || now.getHours() >= cutoff)) start = addBusinessDays(now, 1);
    var a = addBusinessDays(start, min), b = addBusinessDays(start, max);
    var date = el.querySelector('[data-sw-delivery-date]');
    if (date) {
      date.innerHTML = 'Lieferung voraussichtlich <strong>' + fmt(a) + (max > min ? ' – ' + fmt(b) : '') + '</strong>';
    }
    var c = el.querySelector('[data-sw-delivery-cutoff]');
    if (c && cutoff !== null && isWorkday && now.getHours() < cutoff) {
      var left = new Date(now); left.setHours(cutoff, 0, 0, 0);
      var mins = Math.max(0, Math.round((left - now) / 60000));
      var h = Math.floor(mins / 60), m = mins % 60;
      c.textContent = 'Bestellst du in den nächsten ' + (h ? h + ' Std. ' : '') + m + ' Min., geht dein Paket heute raus.';
      c.hidden = false;
    }
  }

  /* ---------- Sticky-Kaufleiste ---------- */
  function initSticky(bar) {
    var target = document.getElementById('sw-offer') || document.getElementById('kaufen');
    var form = document.querySelector('.product-form');
    var final = document.querySelector('[data-sw-final]');
    if (!target || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var pastBuy = false, finalVisible = false;
    function render() { bar.classList.toggle('is-visible', pastBuy && !finalVisible); }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { pastBuy = !e.isIntersecting && e.boundingClientRect.top < 0; });
      render();
    }).observe(form || target);
    if (final) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { finalVisible = e.isIntersecting; });
        render();
      }, { rootMargin: '0px 0px -20% 0px' }).observe(final);
    }
  }

  /* ---------- Wecker-Rechner ---------- */
  function initCalc(root) {
    var alarms = root.querySelector('[name="sw-alarms"]');
    var days = root.querySelector('[name="sw-days"]');
    var outA = root.querySelector('[data-sw-out-alarms]');
    var outD = root.querySelector('[data-sw-out-days]');
    var big = root.querySelector('[data-sw-calc-big]');
    var mins = root.querySelector('[data-sw-calc-mins]');
    var snooze = parseInt(root.dataset.snooze || '9', 10);
    function update() {
      var a = +alarms.value, d = +days.value;
      outA.textContent = a; outD.textContent = d;
      big.textContent = (a * d * 52).toLocaleString('de-DE') + '×';
      if (mins) {
        var h = Math.round(((a - 1) * snooze * d * 52) / 60);
        mins.textContent = h.toLocaleString('de-DE');
      }
    }
    [alarms, days].forEach(function (i) { i.addEventListener('input', update); });
    update();
  }


  /* ---------- Paketauswahl (Bundle) ---------- */
  var eur = function (cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  };
  function initBundle(root) {
    if (root.dataset.swReady) return;
    root.dataset.swReady = '1';
    var tiers = [].slice.call(root.querySelectorAll('[data-sw-tier]'));
    var addons = [].slice.call(root.querySelectorAll('[data-sw-addon]'));
    var sumEl = root.querySelector('[data-sw-sum]');
    var shipEl = root.querySelector('[data-sw-ship-note]');
    var btn = root.querySelector('[data-sw-bundle-add]');
    var err = root.querySelector('[data-sw-bundle-error]');
    var threshold = parseInt(root.dataset.threshold || '0', 10);
    var shipCost = parseInt(root.dataset.ship || '0', 10);
    var wasMult = parseInt(root.dataset.wasMult || '0', 10);
    var data = { variants: [] };
    try { data = JSON.parse(root.querySelector('[data-sw-variants]').textContent); } catch (e) {}
    var priceOf = function (id) {
      var v = data.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      return v ? v.price : (data.variants[0] ? data.variants[0].price : 0);
    };
    function selected() { return tiers.filter(function (t) { return t.querySelector('input[type=radio]').checked; })[0] || tiers[0]; }
    function chosenIds(tier) {
      var sel = [].slice.call(tier.querySelectorAll('[data-sw-variant-select]'));
      var qty = parseInt(tier.dataset.qty, 10);
      if (!sel.length) {
        var first = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
        var ids = []; for (var i = 0; i < qty; i++) ids.push(first.id); return ids;
      }
      return sel.map(function (x) { return x.value; });
    }
    function update() {
      var cur = selected();
      tiers.forEach(function (t) {
        var on = t === cur;
        t.classList.toggle('is-selected', on);
        var qty = parseInt(t.dataset.qty, 10), off = parseInt(t.dataset.off || '0', 10);
        var ids = chosenIds(t);
        var regular = ids.reduce(function (a, id) { return a + priceOf(id); }, 0);
        var total = regular - off * qty;
        if (wasMult > 1) regular = total * wasMult;
        var tEl = t.querySelector('[data-sw-total]'); if (tEl) tEl.textContent = eur(total);
        var uEl = t.querySelector('[data-sw-unit]'); if (uEl) uEl.textContent = eur(Math.round(total / qty));
        var sEl = t.querySelector('[data-sw-save]'); if (sEl) sEl.textContent = eur(regular - total);
        var wEl = t.querySelector('[data-sw-was]'); if (wEl) wEl.textContent = eur(regular);
        var wuEl = t.querySelector('[data-sw-was-unit]'); if (wuEl) wuEl.textContent = eur(Math.round(regular / qty));
        t.dataset.total = total;
      });
      var sum = parseInt(cur.dataset.total || '0', 10);
      addons.forEach(function (a) { if (a.checked) sum += parseInt(a.dataset.price || '0', 10); a.closest('.sw-addon').classList.toggle('is-checked', a.checked); });
      var base = parseInt(cur.dataset.total || '0', 10);
      addons.forEach(function (a) {
        var hint = a.closest('.sw-addon').querySelector('[data-sw-addon-unlock]');
        if (!hint) return;
        var p = parseInt(a.dataset.price || '0', 10);
        hint.hidden = !(threshold > 0 && base < threshold && base + p >= threshold);
      });
      sumEl.textContent = eur(sum);
      if (threshold > 0 && sum >= threshold) {
        shipEl.textContent = 'Versandkostenfrei';
        shipEl.classList.add('is-free');
      } else if (threshold > 0) {
        shipEl.textContent = 'zzgl. ' + eur(shipCost) + ' Versand · noch ' + eur(threshold - sum) + ' bis versandkostenfrei';
        shipEl.classList.remove('is-free');
      } else {
        shipEl.textContent = 'zzgl. Versand';
      }
    }
    root.addEventListener('change', update);
    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e.target.closest('select')) { t.querySelector('input[type=radio]').checked = true; }
        update();
      });
    });
    btn.addEventListener('click', function () {
      var cur = selected();
      var counts = {};
      chosenIds(cur).forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      addons.forEach(function (a) { if (a.checked) items.push({ id: parseInt(a.value, 10), quantity: 1 }); });
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      btn.disabled = true; btn.classList.add('is-loading'); err.hidden = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Fehler');
          if (drawer && res.j.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res.j);
          } else {
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          }
        })
        .catch(function (e) { err.textContent = 'Das hat nicht geklappt: ' + e.message; err.hidden = false; })
        .finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    });
    update();
  }

  /* ---------- Weiche Sprünge zum Angebot ---------- */
  function initScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-sw-scroll]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var t = document.getElementById(id) || document.getElementById('kaufen');
      if (!t) return;
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function init() {
    document.querySelectorAll('[data-sw-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-sw-social]').forEach(initSocial);
    document.querySelectorAll('[data-sw-rail]').forEach(initRail);
    document.querySelectorAll('[data-sw-delivery]').forEach(initDelivery);
    document.querySelectorAll('[data-sw-sticky]').forEach(initSticky);
    document.querySelectorAll('[data-sw-calc]').forEach(initCalc);
    document.querySelectorAll('[data-sw-bundle]').forEach(initBundle);
    initScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme-Editor: Sektionen neu initialisieren, wenn sie neu geladen werden.
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target;
    r.querySelectorAll('[data-sw-gallery]').forEach(initGallery);
    r.querySelectorAll('[data-sw-rail]').forEach(initRail);
    r.querySelectorAll('[data-sw-delivery]').forEach(initDelivery);
    r.querySelectorAll('[data-sw-calc]').forEach(initCalc);
    r.querySelectorAll('[data-sw-bundle]').forEach(initBundle);
  });
})();
